module.exports = __webpack_public_path__ + "static/img/yangguangxingui.b7babcd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/yangguangxingui.png
// module id = 3mTs
// module chunks = 1